import React, { useRef, useState } from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import classnames from 'classnames';
import { Popover } from '../../../../global/popover/popover';
import { OperatorsList } from '../operators-list/operators-list';
import OperatorColumn from '../../../../global/operator-column/operator-column';
import { MultiSelectButton } from '../../../../global/multi-select/multi-select-button';
import MultiSelectWithRoleHeader from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-header';
import { MultiSelectWithRoleList } from '../../../../global/multi-select-with-role.tsx/multi-select-with-role-list';
import { IEntityRoleDTO } from '../../../../../api/events.dao';
import { IUserOperatorDTO, OperatorRole } from '../../../../../api/operators.dao';
import { IOperatorDetailsDTO } from '../../../../../api/rooms.dao';
import { cancelText } from '../../../../../constants/common-labels.constants';

interface IProps {
    operatorsListToAdd: IUserOperatorDTO[];
    operators: IOperatorDetailsDTO[];
    operatorRoles: IEntityRoleDTO[];
    intl: IntlShape;
    initOperatorsData: (query?: string) => Promise<void>;
    addOperatorsToTheMeeting: (operatopsList: IUserOperatorDTO[]) => void;
    setOperatorRole: (email: string, role: OperatorRole) => void;
    removeOperator: (email: string) => void;
}

const OperatorsListButton = (props: IProps) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const roleButtonRef = useRef(null);
    const {
        addOperatorsToTheMeeting,
        setOperatorRole,
        removeOperator,
        initOperatorsData,
        operators,
        operatorRoles,
        operatorsListToAdd,
        intl,
    } = props;

    const formattedOperators = operators
        .map(item => ({
            fullName: `${item.firstName} ${item.lastName}`,
            ...item,
            user: item.user
        }))
        .sort((a, b) => a.lastName.localeCompare(b.lastName));


    const handleClickOutside = e => {
        // prevent to close Popover when user clicks on MultiSelectButton(react-tiny-popover), which is outside of Popover
        if (!e.composedPath()
            .filter(elem => elem.tagName === 'DIV')
            .some(elem => elem.classList.value.includes('react-tiny-popover-container'))
        ) {
        setIsModalOpen(false);
        }
    };

    return (
        <div
            className={classnames('operators-column', {
              'operators-column--active': isModalOpen,
            })}
            ref={roleButtonRef}
            onDoubleClick={e => e.stopPropagation()}
        >
            <div className='operators-column--wrapper' onClick={() => setIsModalOpen(prev => !prev)}>
                <OperatorColumn operators={operators} />
            </div>
            <Popover
                padding={0}
                isOpen={isModalOpen}
                buttonRef={roleButtonRef}
                customWidth={343}
                withCloseIcon
                onClose={() => setIsModalOpen(false)}
                onClickOutside={e => handleClickOutside(e)}

            >
                <OperatorsList
                    classname='action-on-hover'
                    operators={formattedOperators}
                    onOperatorRoleChange={setOperatorRole}
                    removeOperator={removeOperator}
                />
                <div className='add-button-wrapper'>
                    <MultiSelectButton
                        className='default-button--no-border add-attendee-btn'
                        popoverClassName='multi-select-with-role event_form__items-section m-bottom-0px'
                        searchWithDebounce
                        keyProperty='email'
                        nameProperty='fullName'
                        items={operatorsListToAdd}
                        value={formattedOperators}
                        disabled={formattedOperators}
                        onChange={addOperatorsToTheMeeting}
                        onClick={initOperatorsData}
                        filterHandler={initOperatorsData}
                        renderHeader={MultiSelectWithRoleHeader}
                        renderSelectList={rest =>
                            <MultiSelectWithRoleList
                                entityRoleKey='operatorRole'
                                intlRoleKey='operators.roleOptions'
                                entityRolesList={operatorRoles}
                                intl={intl}
                                {...rest}
                            />
                        }
                        text={<FormattedMessage
                            id='oe.operators.add'
                            description='Button text'
                            defaultMessage='{prefix} Add Operators'
                            values={{prefix: '+'}}
                        />}
                        applyButtonText={<FormattedMessage
                            id='oe.common.add'
                            description='Button text'
                            defaultMessage='{prefix} Add Operators'
                        />}
                        resetButtonText={cancelText()}
                    />
                </div>
            </Popover>

        </div>
    );
};

export {
    OperatorsListButton
};